// 정산 설정 묶음.
//   배너 문구는 미팅지도 관리 ⚙️ 설정으로(2026-09-01),
//   회사별 일일콜 표시는 상품 관리 > "회사에 붙이기" 로(2026-09-20) 각각 이관돼 여기엔 정산만 남았다.
import React from 'react';
import {
  BankCodeSettings,
  SettlementSettings,
} from './SettlementSettingsPanels';

export function OperationsAndSettlementSection({
  settlementCompanies,
  settlementLoading,
}) {
  return (
    <div className="grid gap-4">
      <BankCodeSettings />
      <SettlementSettings
        settlementCompanies={settlementCompanies}
        settlementLoading={settlementLoading}
      />
    </div>
  );
}
